import styled from "styled-components";
import { useQueryClient } from "@tanstack/react-query";
import { FC } from "react";

import ActionsDropdown, {
  ActionsDropdownButton,
} from "@/components/ActionsDropdown";
import { ActionsWrap, Td } from "@/components/Table";
import { ReactComponent as TrashIcon } from "@/assets/icons/trashbin.svg";
import useAlerts from "@/hooks/useAlerts";
import { api } from "@/utils/api";

const Content = styled.div`
  display: flex;
  align-items: center;
`;

const Thumb = styled.img`
  margin-right: 8px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
`;

interface Props {
  channel: {
    id: number;
    name: string;
    thumbnail: string | null;
  };
}

const TableRow: FC<Props> = ({ channel }) => {
  const alerts = useAlerts();

  const queryClient = useQueryClient();

  const onDelete = async () => {
    try {
      const confirm = await alerts.confirm(
        `Are you sure you want to detach this page from business account?`
      );

      if (!confirm) return;

      await api.delete(`/v1/meta-business-accounts/channels`, {
        data: {
          channels: [channel.id],
        },
      });

      await queryClient.invalidateQueries(["meta_business_accounts"]);

      alerts.success("Page was successfully detached");
    } catch (e) {
      alerts.error();
    }
  };
  return (
    <tr>
      <Td>
        <Content>
          {!!channel.thumbnail && <Thumb src={channel.thumbnail} />}
          {channel.name}
        </Content>
      </Td>
      <Td $actionsCol>
        <ActionsWrap>
          <ActionsDropdown>
            <ActionsDropdownButton as="button" onClick={onDelete}>
              <span>
                <TrashIcon />
              </span>
              Remove
            </ActionsDropdownButton>
          </ActionsDropdown>
        </ActionsWrap>
      </Td>
    </tr>
  );
};

export default TableRow;
